import { useBehaviorReflection } from '@/hooks/useBehaviorReflection';
import { useLanguage } from '@/i18n/LanguageContext';
import { Eye } from 'lucide-react';

const BehaviorInsight = () => {
  const { insight } = useBehaviorReflection();
  const { t } = useLanguage();

  if (!insight) return null;

  const timeLabel = t(`time_${insight.timeOfDay}`) || insight.timeOfDay;
  const categoryLabel = t(`cat_${insight.topCategory}`) || insight.topCategory;

  return (
    <div className="p-4 border border-border/20 bg-gradient-to-br from-muted/10 to-transparent rounded-xl">
      <div className="flex items-start gap-3">
        <Eye className="w-4 h-4 text-muted-foreground/40 mt-0.5 flex-shrink-0" />
        <div className="space-y-1">
          <p className="text-xs text-muted-foreground/60 uppercase tracking-wider">
            {t('behavior_insight') || 'The site notices'}
          </p>
          <p className="text-sm text-foreground/70 font-light">
            {(t('insight_pattern') || `You're drawn to {category}. You explore most in the {time}.`)
              .replace('{category}', categoryLabel)
              .replace('{time}', timeLabel)}
          </p>
          <p className="text-[10px] text-muted-foreground/30">
            {insight.uniqueRooms} {t('rooms')} · {insight.totalVisits} {t('visits_count') || 'visits'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BehaviorInsight;
